import { PropsWithChildren } from 'react';

import { ScreenReaderOnly } from '@opendoor/bricks/utils';

const Fieldset: React.FC<PropsWithChildren<{ questionTitle: string }>> = ({
  questionTitle,
  children,
}) => (
  <fieldset style={{ border: 'none', padding: '0', margin: '0' }}>
    <ScreenReaderOnly as="legend">{questionTitle}</ScreenReaderOnly>
    {children}
  </fieldset>
);

export default Fieldset;
